import { environment } from '@/environments/environment';

export function isShoutAgencyBrand(
  agencyId: string | null | undefined,
  shoutAgencyId: string = environment.shoutAgencyId,
): boolean {
  return !!agencyId && agencyId === shoutAgencyId;
}

export function withShoutAgencyBrandFilter<T extends object>(
  filter: T,
  showShoutAgencyBrands: boolean,
): T & { excludeAgencyId?: string } {
  if (showShoutAgencyBrands) {
    return filter;
  }

  return {
    ...filter,
    excludeAgencyId: environment.shoutAgencyId,
  };
}
